// extracted by mini-css-extract-plugin
export default {"mainBox":"navbar_mainBox__ClOPN","nav":"navbar_nav__VJoo1"};